import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import VoltageChart from "../components/VoltageChart";
import ThdChart from "../components/ThdChart";
import VoltagesCard from "../components/VoltagesCard";
import VoltagesReportDialog from "../components/VoltagesReportDialog";

function breakLargeGaps(data, maxGapMs = 60 * 60 * 1000) {
  if (!data.length) return [];
  const result = [data[0]];
  for (let i = 1; i < data.length; i++) {
    const prev = data[i - 1];
    const curr = data[i];
    const gap = curr.time - prev.time;
    if (gap > maxGapMs) {
      result.push({ time: prev.time + 1, VL1: null, VL2: null, VL3: null });
      result.push({ time: curr.time - 1, VL1: null, VL2: null, VL3: null });
    }
    result.push(curr);
  }
  return result;
}

function VoltagesPage({ deviceType = "analyzer" }) {
  const { t } = useTranslation();
  const { deviceId, virtualId } = useParams();
  const [fazData, setFazData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [phaseMax, setPhaseMax] = useState({});
  const [lineMax, setLineMax] = useState({});
  const [phaseMin, setPhaseMin] = useState({});
  const [lineMin, setLineMin] = useState({});
  const [thdData, setThdData] = useState({});
  const [fazRange, setFazRange] = useState("1D");
  const [lineRange, setLineRange] = useState("1D");
  const [reportOpen, setReportOpen] = useState(false);

  // ?? Sanal cihaz m�? LocalStorage'dan kontrol et
  const saved = JSON.parse(localStorage.getItem("selectedDevice") || "{}");
  const isVirtual = saved.mode === "virtual";

  // ?? Sanal cihazsa virtualId'yi, de�ilse deviceId'yi kullan
  const targetId = isVirtual ? saved.virtualId : deviceId;

  // ?? Backend URL
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // ?? �stek yap�lacak endpoint prefix'i
  const ENDPOINT_PREFIX = isVirtual
    ? "/virtual"
    : deviceType === "gruparge"
      ? "/gruparge"
      : deviceType === "reactive"
        ? "/reactive"
        : deviceType === "multimeter"
          ? "/multimeter"
          : "/measurements";




  function getRangeMs(r) {
    switch (r) {
      case "1H": return 1 * 60 * 60 * 1000;
      case "3H": return 3 * 60 * 60 * 1000;
      case "6H": return 6 * 60 * 60 * 1000;
      case "12H": return 12 * 60 * 60 * 1000;
      case "1D": return 1 * 24 * 60 * 60 * 1000;
      case "3D": return 3 * 24 * 60 * 60 * 1000;
      case "1W": return 7 * 24 * 60 * 60 * 1000;
      default: return 1 * 24 * 60 * 60 * 1000;
    }
  }

  async function downloadVoltageReport(format = "csv", type = "phase") {
    const end = new Date();
    const start = new Date(end.getTime() - getRangeMs(fazRange));

    const url = `${API_BASE}/reports/export-voltages?deviceId=${targetId}&deviceType=${deviceType}&start=${start.toISOString()}&end=${end.toISOString()}&format=${format}&voltageType=${type}`;

    window.open(url, "_blank");
  }

  // fetch fonksiyonlar� ayn�, de�i�medi...
  async function fetchFazVoltages() {
    try {
      const end = new Date();
      const start = new Date(end.getTime() - getRangeMs(fazRange));
      const url = `${API_BASE}${ENDPOINT_PREFIX}/voltages?deviceId=${targetId}&start=${start.toISOString()}&end=${end.toISOString()}`;
      const res = await fetch(url);
      const rows = await res.json();

      const formatted = rows.map((r) => ({
        time: new Date(r.time).getTime(),
        VL1: r.VL1,
        VL2: r.VL2,
        VL3: r.VL3,
      }));
      setFazData(breakLargeGaps(formatted));
    } catch (err) {
      console.error("fetchFazVoltages error:", err);
    }
  }

  async function fetchLineVoltages() {
    // Grup Arge'de hat voltaj� yok
    if (deviceType === "gruparge") {
      setLineData([]);
      return;
    }

    try {
      const end = new Date();
      const start = new Date(end.getTime() - getRangeMs(lineRange));
      const url = `${API_BASE}${ENDPOINT_PREFIX}/line-voltages?deviceId=${targetId}&start=${start.toISOString()}&end=${end.toISOString()}`;
      const res = await fetch(url);
      const rows = await res.json();
      const formatted = rows.map((r) => ({
        time: new Date(r.time).getTime(),
        VL1: r.VL12,
        VL2: r.VL23,
        VL3: r.VL31,
      }));
      setLineData(breakLargeGaps(formatted));
    } catch (err) {
      console.error("fetchLineVoltages error:", err);
    }
  }

  async function fetchPhaseMax() {
    const res = await fetch(`${API_BASE}${ENDPOINT_PREFIX}/phase-max-voltages?deviceId=${targetId}`);
    const data = await res.json();
    setPhaseMax(data);
  }


  async function fetchLineMax() {
    const res = await fetch(`${API_BASE}${ENDPOINT_PREFIX}/line-max-voltages?deviceId=${targetId}`);
    setLineMax(await res.json());
  }

  async function fetchPhaseMin() {
    const res = await fetch(`${API_BASE}${ENDPOINT_PREFIX}/phase-min-voltages?deviceId=${targetId}`);
    setPhaseMin(await res.json());
  }

  async function fetchLineMin() {
    const res = await fetch(`${API_BASE}${ENDPOINT_PREFIX}/line-min-voltages?deviceId=${targetId}`);
    setLineMin(await res.json());
  }

  async function fetchThd() {
    try {
      const res = await fetch(`${API_BASE}${ENDPOINT_PREFIX}/phase-harmonics?deviceId=${targetId}`);
      const json = await res.json();
      setThdData(json);
    } catch (err) {
      console.error("fetchThd error:", err);
    }
  }

  // useEffect bloklar� ayn�, de�i�medi
  useEffect(() => { if (!targetId) return; fetchFazVoltages(); const i = setInterval(fetchFazVoltages, 5000); return () => clearInterval(i); }, [API_BASE, targetId, fazRange]);
  useEffect(() => { if (!targetId) return; fetchLineVoltages(); const i = setInterval(fetchLineVoltages, 5000); return () => clearInterval(i); }, [API_BASE, targetId, lineRange]);
  // Faz max (Grup Arge'de max/min yok)
  useEffect(() => {
    if (!targetId || deviceType === "reactive" || deviceType === "gruparge" || isVirtual) return;
    fetchPhaseMax();
    const i = setInterval(fetchPhaseMax, 10000);
    return () => clearInterval(i);
  }, [API_BASE, targetId, deviceType]);

  // Hat max (Grup Arge'de max/min yok)
  useEffect(() => {
    if (!targetId || deviceType === "reactive" || deviceType === "gruparge" || isVirtual) return;
    fetchLineMax();
    const i = setInterval(fetchLineMax, 10000);
    return () => clearInterval(i);
  }, [API_BASE, targetId, deviceType]);

  // Faz min (Grup Arge'de max/min yok)
  useEffect(() => {
    if (!targetId || deviceType === "reactive" || deviceType === "gruparge" || isVirtual) return;
    fetchPhaseMin();
    const i = setInterval(fetchPhaseMin, 10000);
    return () => clearInterval(i);
  }, [API_BASE, targetId, deviceType]);

  // Hat min (Grup Arge'de max/min yok)
  useEffect(() => {
    if (!targetId || deviceType === "reactive" || deviceType === "gruparge" || isVirtual) return;
    fetchLineMin();
    const i = setInterval(fetchLineMin, 10000);
    return () => clearInterval(i);
  }, [API_BASE, targetId, deviceType]);
  // THD (Grup Arge'de THD yok)
  useEffect(() => {
    if (!targetId || deviceType === "multimeter" || deviceType === "gruparge") return;
    fetchThd();
    const i = setInterval(fetchThd, 10000);
    return () => clearInterval(i);
  }, [API_BASE, targetId, deviceType]);

  return (
    <div className="p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 gap-6">


      <div
        id="phase-chart"
        className="bg-white rounded-2xl shadow-md p-4 md:p-6 flex flex-col"
      >
        <h2 className="text-lg font-semibold text-gray-800 mb-4">{t('voltages.phaseVoltages')}</h2>
        <VoltageChart
          data={fazData}
          range={fazRange}
          onRangeChange={setFazRange}
          type="faz"
        />
      </div>

      {/* Hat Voltajlar� - Grup Arge'de yok */}
      {deviceType !== "gruparge" && (
        <div
          id="line-chart"
          className="bg-white rounded-2xl shadow-md p-4 md:p-6 flex flex-col"
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">{t('voltages.lineVoltages')}</h2>
          <VoltageChart
            data={lineData}
            range={lineRange}
            onRangeChange={setLineRange}
            type="hat"
          />
        </div>
      )}


      {/* Max/Min De�erler - Grup Arge'de yok */}
      {deviceType !== "reactive" && deviceType !== "gruparge" && !isVirtual && (
        <VoltagesCard
          title={t('voltages.phaseMaxMin')}
          data={{ ...phaseMax, ...phaseMin }}
          type="phase"
        />
      )}

      {deviceType !== "reactive" && deviceType !== "gruparge" && !isVirtual && (
        <VoltagesCard
          title={t('voltages.lineMaxMin')}
          data={{ ...lineMax, ...lineMin }}
          type="line"
        />
      )}


      {/* THD - Grup Arge'de yok */}
      {deviceType !== "multimeter" && deviceType !== "gruparge" && (
        <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 flex flex-col md:col-span-2">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            {t('voltages.thd')}
          </h2>
          <ThdChart data={thdData} />
        </div>
      )}


      <div className="flex items-center justify-start md:col-span-2 mb-2">
        <button
          onClick={() => setReportOpen(true)}
          className="bg-sky-600 text-white px-3 py-2 rounded-md hover:bg-sky-700 text-sm"
        >
          {t('voltages.reportButton')}
        </button>
      </div>
      <VoltagesReportDialog
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        deviceId={targetId}
        deviceType={deviceType}
        API_BASE={API_BASE}
        getRangeMs={getRangeMs}
        fazRange={fazRange}
        isVirtual={isVirtual}
      />

    </div>
  );
}

export default VoltagesPage;
